var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 21C17.7469 21 22 16.7468 22 11.5C22 6.25315 17.7469 2 12.5 2C7.25316 2 3.00001 6.25315 3.00001 11.5C2.99787 13.3791 3.55475 15.2165 4.59981 16.7782C4.71571 16.9506 4.49863 18.0417 3.95001 20.05C5.95878 19.5014 7.04938 19.2843 7.22181 19.4002C8.78355 20.4453 10.6209 21.0021 12.5 21Z",
    stroke: "#7C7C7C",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98711 9.5145H16.9571M11.4771 7.57555L10.0929 15.4244M14.8021 7.57555L13.4179 15.4244M8.03711 13.4H16.0071",
    stroke: "#7C7C7C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopics);
export default __webpack_public_path__ + "static/media/topics.e2e8c06dea6463efe5c3623031080e41.svg";
export { ForwardRef as ReactComponent };